import { IIconProps } from './icon';

interface IIcoFiltersMap extends IIconProps {
  isActive?: boolean;
}

export const IcoFiltersMap = ({ style = {}, cy, isActive }: IIcoFiltersMap) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconFiltersMap${cy}`}
    >
      <path
        d="M5.255 6.61C7.275 9.2 11.005 14 11.005 14V20C11.005 20.55 11.455 21 12.005 21H14.005C14.555 21 15.005 20.55 15.005 20V14C15.005 14 18.725 9.2 20.745 6.61C21.255 5.95 20.785 5 19.955 5H6.045C5.215 5 4.745 5.95 5.255 6.61Z"
        fill="white"
      />
      {isActive && <circle cx="4.5" cy="4.5" r="4.5" fill="#BA96D9" />}
    </svg>
  );
};
